import { Component, OnInit } from '@angular/core';
import { LowBalanceNotificationsService } from '../resources/services/low-balance-notifications.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-users-low-balance',
  templateUrl: './users-low-balance.component.html',
  styleUrls: ['./users-low-balance.component.scss']
})
export class UsersLowBalanceComponent implements OnInit {
  cooldownDays: number = 7;
  limit: number = 100;
  limitOptions: number[] = [100, 250, 500, 1000];
  pendingUsers: any[] = [];
  reactedUsers: any[] = [];
  selectedUserIds: Set<string> = new Set();
  
  loadingPending = false;
  loadingReacted = false;
  sending = false;

  constructor(
    private notificationsService: LowBalanceNotificationsService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadPending();
  }

  loadPending() {
    this.loadingPending = true;
    this.notificationsService.getPendingNotifications(this.cooldownDays, this.limit).subscribe(
      (data: any) => {
        this.pendingUsers = data;
        this.selectedUserIds.clear();
        this.loadingPending = false;
      },
      error => {
        this.toastr.error('Failed to load pending users');
        this.loadingPending = false;
      }
    );
  }

  loadReacted() {
    this.loadingReacted = true;
    this.notificationsService.getReactedUsers(this.limit).subscribe(
      (data: any) => {
        this.reactedUsers = data;
        this.loadingReacted = false;
      },
      error => {
        this.toastr.error('Failed to load reacted users');
        this.loadingReacted = false;
      }
    );
  }

  onTabChange(event: any) {
    if (event.index === 0) {
      this.loadPending();
    } else if (event.index === 1) {
      this.loadReacted();
    }
  }

  toggleSelection(userId: string) {
    if (this.selectedUserIds.has(userId)) {
      this.selectedUserIds.delete(userId);
    } else {
      this.selectedUserIds.add(userId);
    }
  }

  selectAll() {
    if (this.selectedUserIds.size === this.pendingUsers.length) {
      this.selectedUserIds.clear();
    } else {
      this.pendingUsers.forEach(u => this.selectedUserIds.add(u._id));
    }
  }

  sendNotifications() {
    if (this.selectedUserIds.size === 0) return;
    
    this.sending = true;
    const userIds = Array.from(this.selectedUserIds);
    this.notificationsService.sendNotifications(userIds).subscribe(
      (res: any) => {
        this.toastr.success(res.message);
        this.sending = false;
        this.loadPending();
      },
      error => {
        this.toastr.error('Failed to send notifications');
        this.sending = false;
      }
    );
  }
}
